module.exports = __webpack_public_path__ + "img/development.8587d81a.png";